module.exports = __webpack_public_path__ + "images/custom-checked-424a20ebc48c4dba8c4c6abfdfa3a16a.svg";